import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export type ButtonToggleValue = string | number | boolean;

export interface ButtonToggleItem {
  label: string;
  value: ButtonToggleValue;
  disabled?: boolean;
  dataCy?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LlButtonToggle',
  props: {
    modelValue: { type: [String, Number, Boolean, null] },
    items: {},
    ariaLabel: {},
    color: { default: 'primary' },
    density: { default: 'default' },
    disabled: { type: Boolean, default: false },
    dataCy: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

/**
 * A segmented control for one exclusive choice out of two or three: the options
 * sit in a single bordered group, so they read as one question rather than as
 * separate buttons. Past three options, or when options need descriptions, use
 * LlSelect or LlRadioGroup instead.
 *
 * Inside a button group Vuetify applies `color` only while an option is selected
 * and `base-color` otherwise, which is what fills the chosen option brand green
 * and leaves the rest on the secondary-button grey. Both are bound per button as
 * well as on the group: VBtnGroup would hand them down through `provideDefaults`,
 * but that chain runs through the host app's own defaults, and a silently
 * unfilled button is indistinguishable from a broken one.
 *
 * `self-start` is load-bearing. `.v-btn-group` is `inline-flex`, but a flex item
 * is blockified to `flex`, and the settings rows nest this in a `flex flex-col`
 * card body — without it the group's border spans the whole column.
 *
 * `border-outline` is the control weight, not the softer `outline-variant` that
 * panels use: this is something you click.
 *
 * `mandatory="force"` keeps the setting answered — clicking the selected option
 * cannot clear it, and a value outside the option set emits the first one rather
 * than rendering a group with nothing lit.
 */


const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createBlock(_component_v_btn_toggle, {
    "model-value": __props.modelValue,
    color: __props.color,
    "base-color": "control-surface",
    density: __props.density,
    disabled: __props.disabled,
    "aria-label": __props.ariaLabel,
    variant: "flat",
    mandatory: "force",
    divided: "",
    border: "",
    class: "self-start border-outline border-opacity-100",
    role: "group",
    "data-cy": __props.dataCy,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(_component_v_btn, {
          key: String(item.value),
          variant: "flat",
          color: __props.color,
          "base-color": "control-surface",
          value: item.value,
          disabled: item.disabled === true,
          "data-cy": item.dataCy
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.label), 1)
          ]),
          _: 2
        }, 1032, ["color", "value", "disabled", "data-cy"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model-value", "color", "density", "disabled", "aria-label", "data-cy"]))
}
}

})